// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f364cc2c","239":"5a7fb247","732":"54e7edd7"}[chunkId] + ".chunk.js";
};